'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkIsChrome = function checkIsChrome() {
  var isChromium = window.chrome;
  var _window$navigator = window.navigator,
    vendor = _window$navigator.vendor,
    userAgent = _window$navigator.userAgent;
  if (userAgent.includes('CriOS')) return true;
  return isChromium !== null && isChromium !== undefined && vendor === 'Google Inc.' &&
  // is not Opera
  !userAgent.includes('OPR') &&
  // is not Edge
  !userAgent.includes('Edge');
};
var isChrome = exports.isChrome = checkIsChrome();